import script from "./TOTPRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./TOTPRegister.vue?vue&type=script&setup=true&lang=js"

import "./TOTPRegister.vue?vue&type=style&index=0&id=7d15c8dc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d15c8dc"]])

export default __exports__